import { DmrFrame } from 'billing/DmrFrame/DmrFrame';
import $ from 'jquery';
import BLayer from 'toolkit/b-layer/b-layer';
import 'toolkit/b-tabsheet/b-tabsheet';

const BIND_CREDIT_CARD = 'bind-credit-card';

export default BLayer.extend(BIND_CREDIT_CARD, {
    inner: true,

    hide(...args) {
        BLayer.fn.hide.apply(this, args);

        this._gateType = null;
        this._psysType = null;
        this._success = false;
        this._subState = null;
    },

    radar: function radar() {
        return radar;
    },

    init(...args) {
        this.templateBlock = 'b-layer';

        BLayer.fn.init.apply(this, args);
    },

    onRender(/* evt, ui */) {
        this.el.style.visibility = '';

        this.states = {
            frame: $('.js-frame', this.$el),
            waiting: $('.js-waiting', this.$el),
            message: $('.js-message', this.$el),
        };
    },

    getData() {
        return $.extend(
            {},
            {
                canHide: true,
                block: 'b-panel',
                mods: [BIND_CREDIT_CARD],
                params: {
                    mods: ['popup', 'service'],
                    close: true,
                    header: {
                        title: 'Настройка оплаты',
                    },
                    view: BIND_CREDIT_CARD,
                    content: {},
                },
            },
        );
    },

    render(...args) {
        if (this._rendered) {
            return;
        }

        this.el.style.visibility = 'hidden';

        this._rendered = false;

        BLayer.fn.render.apply(this, args);

        this._rendered = true;
    },

    // eslint-disable-next-line sonarjs/cognitive-complexity
    setState(state, subState, time) {
        this.render();

        if (!state || !(state in this.states)) {
            state = 'waiting';
        }

        if (!time && typeof subState == 'number') {
            time = subState;
            subState = undefined;
        }

        this.radar('state')('state-' + state, time);

        if (subState) {
            this.radar('state-' + state + '-' + subState, time);
        }

        this._subState = subState;

        if (state) {
            if (this._state) {
                this.$el.removeClass('bind-credit-card_' + this._state);
            }

            this._state = state;

            this.$el.addClass('bind-credit-card_' + this._state);

            this._setContainerPosition();

            for (const name in this.states) {
                if (this.states.hasOwnProperty(name)) {
                    this.states[name][state === name ? 'show' : 'hide']();
                }
            }
        }
    },

    getCurrentState() {
        return this._state;
    },

    getCurrentSubState() {
        return this._subState;
    },

    isErrorState() {
        return (
            this.getCurrentState() === 'message' &&
            this.getCurrentSubState() === 'error'
        );
    },

    isSuccess() {
        return this._success;
    },

    startLoading(action) {
        action.always(() => {
            if (
                _loadingTimeout === this._loadingTimeout &&
                this._loadingTimeout !== null
            ) {
                clearTimeout(this._loadingTimeout);
                this._loadingTimeout = null;
            }
        });

        clearTimeout(this._loadingTimeout);

        const _loadingTimeout = (this._loadingTimeout = setTimeout(() => {
            this.setState('waiting');
        }, 150));

        return action;
    },

    stopLoading() {
        clearTimeout(this._loadingTimeout);
        this.$el.find('.waiting').hide();
    },

    setError(settings) {
        settings || (settings = {});

        if (!settings.footer) {
            settings.footer = 'return';
        }

        settings.state = 'error';

        this.setMessage(settings);
    },

    setMessage(settings) {
        settings || (settings = {});

        this.setState('message', settings.state);

        this.states.message.fest(this.template, {
            block: 'bind-credit-card__message',
            params: settings,
        });
    },

    onDone() {
        this._onDone();
    },

    _onDone() {
        this.hide();
    },

    goToPayment(url) {
        const startTime = new Date().getTime();

        this.startLoading(this._goToPayment(url))
            .done(() => {
                this.setState('frame', new Date().getTime() - startTime);
            })

            .fail(() => {
                this.radar('setrrror')(
                    'seterror-payment',
                    new Date().getTime() - startTime,
                );

                this.setError();
            });
    },

    _goToPayment(url) {
        const startTime = new Date().getTime();

        this.radar('frame');

        const d = new $.Deferred();

        if (this._dmrFrame) {
            this._dmrFrame.destroy();
        }

        this._dmrFrame = new DmrFrame({
            el: this.states.frame[0],
            className: 'bind-credit-card__frame',
        });

        this._dmrFrame.on(DmrFrame.EVENT_PAYMENT_SUCCESS, () => {
            this._success = true;
            this.emit('paySuccess');
        });

        this._dmrFrame.on(DmrFrame.EVENT_PAYMENT_FAIL, () => {
            this._success = false;
            this.setError();
        });

        this._dmrFrame.on(
            DmrFrame.EVENT_CLOSE + ' ' + DmrFrame.EVENT_PAYMENT_CANCEL,
            () => {
                this._onDone();
            },
        );

        this._dmrFrame.on(DmrFrame.EVENT_MESSAGE, (event) => {
            this.radar('frame-message')(
                'frame-message-' + event.type + '-' + event.action,
                new Date().getTime() - startTime,
            );
        });

        this._dmrFrame.on(DmrFrame.EVENT_LOAD_ERROR_TIMEOUT, () => {
            this.radar('frame-timeout', new Date().getTime() - startTime);
        });

        this._dmrFrame.on(DmrFrame.EVENT_RETRY, () => {
            this.emit('repeat');
        });

        this._dmrFrame
            .load(url)
            .then(() => {
                d.resolve();
            })

            .catch(() => {
                d.reject();
            });

        return d;
    },

    getAutopaymentSettingsContainer() {
        return this.$('.js-autopayment')[0];
    },

    hideAutopaymentManual() {
        this.$('.js-autopayment-manual').hide();
    },

    showAutopaymentSpinner() {
        this.$('.js-autopayment-spinner').show();
    },

    hideAutopaymentSpinner() {
        this.$('.js-autopayment-spinner').hide();
    },

    activateTab(tabName) {
        this.$('.b-tabsheet')
            .getBlock()
            .activateTab(tabName === 'autopayment' ? 1 : 0);
    },

    destroy(...args) {
        if (this._dmrFrame) {
            this._dmrFrame.destroy();
            this._dmrFrame = null;
        }

        this._success = false;
        this._subState = null;

        BLayer.fn.destroy.apply(this, args);
    },
});
